import { useTranslation } from 'react-i18next';

import { MOBILE_MEDIA_QUERY } from '../../../../../config/constants';
import { useFitText } from '../../../../../hooks/useFitText';
import { useMediaQuery } from '../../../../../hooks/useMediaQuery';
import { WIDGET_BINGO_LIVE_BUTTON_FONT_SIZE } from '../../../constants';

export function BingoLiveButtonText() {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);
  const fontSizeObj = isMobile ? WIDGET_BINGO_LIVE_BUTTON_FONT_SIZE.mobile : WIDGET_BINGO_LIVE_BUTTON_FONT_SIZE.desktop;

  const textRef = useFitText(fontSizeObj.max, fontSizeObj.min);
  return <span ref={textRef}>{t('prime.bingo.enterLive')}</span>;
}
